/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AlgorithmIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Algorithm',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden="${hidden ? 'true' : 'false'}"
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M31 25.4h-.019l-3.335-5.478A3.588 3.588 0 0025 13.9a3.53 3.53 0 00-.936.139l-3.418-5.615a3.6 3.6 0 10-5.292 0l-3.418 5.615A3.53 3.53 0 0011 13.9a3.588 3.588 0 00-2.646 6.024L5.019 25.4H5A3.6 3.6 0 108.442 30h6.116a3.578 3.578 0 006.884 0h6.116A3.593 3.593 0 1031 25.4zM27.558 28h-6.116a3.584 3.584 0 00-1.142-1.75l3.431-5.392A3.571 3.571 0 0025 21.1a3.53 3.53 0 00.936-.139l3.07 5.044A3.593 3.593 0 0027.558 28zM18 9.6a3.543 3.543 0 00.937-.139l3.417 5.615a3.617 3.617 0 00-.618.924h-7.472a3.6 3.6 0 00-.618-.924l3.417-5.615A3.543 3.543 0 0018 9.6zM14.55 18h6.9a3.564 3.564 0 00.678 1.65l-3.687 5.794A3.56 3.56 0 0018 25.4a3.56 3.56 0 00-.441.044l-3.687-5.794A3.564 3.564 0 0014.55 18zm-4.486 2.961A3.53 3.53 0 0011 21.1a3.571 3.571 0 001.27-.242l3.43 5.392A3.584 3.584 0 0014.558 28H8.442a3.593 3.593 0 00-1.448-2z"
    />
  </svg>`;
};
